import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import { Routes } from 'routing';

import AddOnStore from './Store';

const Blocks = () => {
	return (
		<Switch>
			<Route path={Routes.BLOCKS_STORE_TAB} component={AddOnStore} />
			<Redirect to={Routes.BlockStoreTab('all')} />
		</Switch>
	);
};

export default Blocks;
